export const MenusClassement = () => {
    const datas = [
        { name: 'Catégories & Familles', href: '/categories-et-familles' },
        { name: 'Films & séries', href: '/films-et-series' },
        { name: 'Expériences', href: '/experiences' },
        { name: 'Liens', href: '/liens' }
    ];
    return datas;
}